import { Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

// Components
import TextInput from '../../../components/UI/TextInput';

// Services
import { LOCAL_STORAGE_KEYS } from '../../../../global/const';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { PATCH } from '../../../services/rest.service';
import AdminChangePasswordSchema from '../../../validationSchema/account/AdminChangePasswordSchema';

const ChangePasswordForm = (props) => (
  <Formik
    initialValues={{
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    }}
    onSubmit={(values) => {
      props.onSubmit(values);
    }}
    validationSchema={AdminChangePasswordSchema}
  >
    {(renderProps) => {
      const { values, touched, errors, handleChange, handleBlur, handleSubmit } = renderProps;
      return (
        <form className="form-horizontal" onSubmit={handleSubmit}>
          <TextInput
            id="oldPassword"
            type="password"
            size="col-12 col-md-6"
            label="Current Password"
            placeholder="Enter current password"
            error={touched.oldPassword && errors.oldPassword}
            value={values.oldPassword}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <TextInput
            id="newPassword"
            size="col-12 col-md-6"
            type="password"
            label="New Password"
            placeholder="Enter new password"
            error={touched.newPassword && errors.newPassword}
            value={values.newPassword}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <TextInput
            id="confirmNewPassword"
            size="col-12 col-md-6"
            type="password"
            label="Repeat New Password"
            placeholder="Confirm your new password"
            error={touched.confirmNewPassword && errors.confirmNewPassword}
            value={values.confirmNewPassword}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          {/*Submit Button*/}
          <button type="submit" className="btn btn-primary mt-3">
            Change Password
          </button>
        </form>
      );
    }}
  </Formik>
);

const AdminChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChangePassword = async (formData) => {
    dispatch(showLoading('Please wait...'));
    try {
      const res = await PATCH(`/admin/user/changePassword`, formData);
      localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, res.access_token);
      dispatch(hideLoading());
      navigate('/admin/dashboard');
      toast.success('Password changed successfully! You will be logged out from everywhere else');
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-lg-9 mb-5">
            <div className="card">
              <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">Change Password</h3>
              </div>
              <div className="card-body">
                <ChangePasswordForm onSubmit={handleChangePassword} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminChangePassword;
